import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'
import _ from 'lodash'

const service = new ApolloClientService()

export default class Regimen {
  getAutoAssignedRegimens = (patient) => {
    return new Promise((resolve, reject) => {
      service
        .getAutoAssignedRegimens(patient)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getRegimens = (filters) => {
    return new Promise((resolve, reject) => {
      service
        .getRegimens(filters)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve({ ...data, filters })
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  assignRegimen = (regimen, regs) => {
    var regimens = JSON.parse(JSON.stringify(regs))
    if (regimens && regimens.length == 0) regimens = [regimen]
    else regimens.push(regimen)
    return regimens
  }

  removeRegimen = (regId, regs) => {
    var regimens = JSON.parse(JSON.stringify(regs))
    _.remove(regimens, { _id: regId })
    return regimens
  }
}
